import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const state = {
	items: [],
	item: [],
	index: '',
	sortBy: '',
	sortDesc: '',
	errors: [],
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
	getErrors: state => {
		return state.errors;
	},
};

const actions = {
	getDetail: async (context, data) => {
		let url = 'incomings/getdetail';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						code: data.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			await context.commit('setItems', res.data.data);
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	getDetailSingle: async (context, data) => {
		let url = 'incomings/getdetailsingle';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						code: data.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			await context.commit('setItems', res.data.data);
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	saveInventory: async (context, data) => {
		let url = 'incomings/saveinventory';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: data.payload,
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			await context.commit('setItems', []);
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	saveDdt: async (context, data) => {
		let url = 'incomings/saveddt';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: data.payload,
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);
			await context.commit('setItems', []);
			//await context.commit('setItems', []);
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	getItemForApp: async (context, data) => {
		let url = 'incomings/getitemforapp';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						code: data.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			await context.commit('setItems', res.data.data);
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	subItem: async (context, data) => {
		let url = 'incomings/subitem';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						code: data.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);
			if (res.data?.notifies && Array.isArray(res.data?.notifies) && res.data?.notifies.length > 0) {
				/*const lists = context.rootGetters['notify/getItems'];
				for (let el of res.data?.notifies) {
					lists.push(el);*/
				context.commit('notify/addItems', res.data?.notifies, { root: true });
				//}
				//await context.commit('notifies/addItems', res.data.notifies, { root: true });
			}
			await context.commit('setItems', res.data.data);
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	updateItem: async (context, data) => {
		let url = 'incomings/updateitem';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						code: data.code,
						itemid: data.itemid,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			await context.commit('setItems', res.data.data);
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	subUpdateItem: async (context, data) => {
		let url = 'incomings/subupdateitem';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						code: data.code,
						itemid: data.itemid,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			await context.commit('setItems', res.data.data);
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},

	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setItem', []);
		context.commit('setIndex', '');
	},
};
const mutations = {
	setItems: async (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setErrors: (state, value) => {
		state.errors.push(value);
	},
	resetErrors: (state, value) => {
		state.errors = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
